export default Object.freeze({
  // 環境変数へのアクセスを追加
  ENV: process.env,
  // LocalStrage保存名称
  SESSION_TOKEN_NAME: 'sessionTokenAdmin',
  // セッション有効期限（分）
  SESSION_TIME: 20,
  // セッション有効期限切れ警告（分）0:警告しない
  SESSION_ALERT_TIME: 1,
  // 各種設定
  MEMBERS_PER_PAGE: 10,
  USERS_PER_PAGE: 10,

  // コラムイメージ参照場所
  COLUMN_IMAGE_PATH: '/columnimg/'
})



// WEBPACK FOOTER //
// ./src/setting/index.js